import { Box } from "@mui/material";
import WidgetCard from "@arelia-components/ui-atoms/WidgetCard";
import { Widget } from "@arelia-types/widget";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

type Props = {
  loading: boolean;
  widgetConfig: Widget;
  data: {
    Premium: { paid: number; free: number };
    PremiumMyFans: { paid: number; free: number };
    Starter: number;
  };
};

export default function PlanBreakdownPresenter({ widgetConfig, loading, data }: Props) {
  const labels: (string)[] = [
    "Starter",
    "Premium",
    "Premium + My Fans",
  ];

  const paidData = [0, data.Premium.paid, data.PremiumMyFans.paid];
  const freeData = [data.Starter, data.Premium.free, data.PremiumMyFans.free];

  const options: any = {
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top" as const,
        display: false,
      },
      title: {
        display: false,
        text: "Chart.js Bar Chart",
      },
      datalabels: {
        font: {
          weight: 500,
        },
        formatter: (v: number) => `${v}`,
      },
    },
    scales: {
      y: {
        min: 0,
        ticks: {
          display: false,
        },
        border: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  };

  const defaultView =
    <Bar
      plugins={[ChartDataLabels]}
      options={{
        ...options,
        plugins: {
          ...options.plugins,
          tooltip: {},
          datalabels: {
            formatter: (v: number) => '',
          }
        }
      }}
      data={{
        labels: ['', ''],
        datasets: [
          {
            data: [30, 70],
            backgroundColor: ["#f6f6f6", "#c8c8c8"],
          },
        ],
      }}
    />;

  const dataView =
    <Bar
      plugins={[ChartDataLabels]}
      options={options}
      data={{
        labels: labels as any,
        datasets: [
          {
            label: "Paid",
            data: paidData,
            datalabels: { align: "start", anchor: "end", color: "#fff" },
            backgroundColor: "#06B2DA",
            stack: "plans",
          },
          {
            label: "Free",
            data: freeData,
            datalabels: { align: "start", anchor: "end", color: "#fff" },
            backgroundColor: "#25BB9D",
            stack: "plans",
          },
        ],
      }}
    />;

  return (
    <WidgetCard
      widgetId={widgetConfig.id}
      title={widgetConfig.name}
      loading={loading}
      widgetConfig={widgetConfig}
      disableFavorite={true}
    >
      <Box sx={styles.container}>
        {data ? dataView : defaultView}
      </Box>
    </WidgetCard>
  );
}

const styles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    display: "flex",
    paddingTop: "20px",
    flex: 1,
  },
};
